var SpotDesc = {
	node :null,
	current: 2048,
	audio:null,
	icon:null,
	isMuted:false,
	lastDesc:null,

	init: function() {
		SpotDesc.node = $("<div id='spotdesc'><span class='title'></span><a class='x speaks' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS' href='#' onclick='SpotDesc.hide();'>×</a><div class='cnt'><div class='txt'></div></div></div>");
		$("#overlay").append(SpotDesc.node);
		AppEvent.on(player, "HOTSPOT.CREATED", function(spot) {
			if (spot.properties.place.place_type == "description") {
				spot.noMore();
				spot.preventShowingInfo = true;
			}

		});
		AppEvent.on(player, "HOTSPOT.STARTLOOKING", SpotDesc.hotspot);
		AppEvent.on(player, "placeReady", function(pe) { SpotDesc.hide();});

		AppEvent.on(player, "PLAYER.KEYUP", function(event) {
			if ($("#spotdesc").hasClass("toggle")) {
				player.blockBackspace = true;			
				if (event.key == 'Escape' || event.key == 'Backspace') {
					SpotDesc.hide();
				}
			}
		});

		SpotDesc.lightbox = $("<div id='lightbox'><a class='x speaks' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS' href='#'' onclick='SpotDesc.hideLightbox();'>×</a><img src='' width='100%'></div>");
		$("#overlay").append(SpotDesc.lightbox);
	},

	hide: function() {
		$("#spotdesc").removeClass("toggle");
		SpotDesc.hideLightbox();
		SpotDesc.lastDesc = null;
//		$("#spotdesc").css("visibility", "hidden");
	},

	hideLightbox: function() {
		SpotDesc.lightbox.hide();
	},

	hotspot: function(spot) {
		
		if (spot.properties.place.place_type == "description") {
			spot.noMore();
			spot.preventShowingInfo = true;
			spot.properties.place.dd.description = spot.properties.place.dd.description.replace(/\r\n/g, '<br />');
			spot.properties.place.dd.description = spot.properties.place.dd.description.replace(/\n/g, '<br />');

			if (SpotDesc.lastDesc != spot.properties.place.place_id) $("#spotdesc").addClass("toggle");
			else {
				$("#spotdesc").removeClass("toggle");
				SpotDesc.lastDesc = null;
				return;
			}

			$("#spotdesc .cnt .txt").html(spot.properties.place.dd.description.autoLink({"target": "_blank"}));
			
			setTimeout(function() {
				var h = $("#spotdesc .cnt .txt").height() + 20;
				
				if (h < 250) $("#spotdesc").css("height", (h + 60) + "px");
				else if (h > 250 && h < $(window).height() - 100) $("#spotdesc").css("height", (h + 60) + "px");
				else if (h > $(window).height() - 200) $("#spotdesc").css("height", ($(window).height() - 200) + "px");
				
				if (spot.properties.place.dd.action != undefined && spot.properties.place.dd.action != "") {
					$("#spotdesc .cnt .txt img").css("cursor", "pointer");
					$("#spotdesc .cnt .txt img").on("click", function() {
						//player.go(spot.properties.place.dd.action, 0);
						$.getJSON("placeloader.php?ident=" + spot.properties.place.dd.action, function(result) {
							if ($(window).width() >= 480) SpotDesc.lightbox.css("width", ($(window).width() - 380) + "px");
							SpotDesc.lightbox.find("img").attr("src", "../data/" + result.properties.image);
							SpotDesc.lightbox.show();
						});
					});
				}
				
			}, 350);
			//$("#spotdesc .title").html(spot.properties.place.place_name);

			SpotDesc.lastDesc = spot.properties.place.place_id;
		} else {
			SpotDesc.hide();
		}
	}
}

PluginManager.add(SpotDesc);